<template>
    <div class="Harmonic">
        <div class="power-data" v-for="item in deviceLoops">
            <div class="tit">{{AreaName(item.aid)}} <span style="font-weight: 400;vertical-align: 1px;color: #CCCCCC;margin:0 5px"> |</span> {{item.loopName}}</div>
            <div class="Harmonic-data">
                <div class="real-data">
                    <div class="row-data row-center">
                        <div class="left row-center">
                            <div class="data" v-for="real in options">
                                <div class="name">{{real.type}}</div>
                                <div class="details">
                                    <template v-for="detail in real.details">
                                            <div
                                                class="row-center row"
                                                style="justify-content: flex-start"
                                                v-for="(v, k) in detail.data"
                                                :key="k"
                                            >
                                            <div  class="key">
                                                {{ k }}
                                            </div>
                                            <div class="val row-center" style="justify-content: space-between">
                                                <span>{{
                                                mqttval(item.subLoopUrl+ "/"+v, detail.multiple) +
                                                    (detail.unit ? ` ${detail.unit}` : "")
                                                }}</span>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div  class="location-right">
                            <div v-if="fow(item) > 4" class="location-and">
                                <div class="location-img">
                                    <img src="@/assets/img/warning.png" alt=""/>
                                </div>
                                <div class="location-orag">电流、电压谐波超出允许范围!</div>
                            </div>
                            <div v-else class="location-title">当前谐波在允许范围内</div>
                            <div class="location-item"> 谐波对供电线路产生了附加损耗，造成电能的浪费；影响各种电气设备的正常工作，造成设备损坏，甚至引起严重的责任事故；对危害其他系统及电力用户。 </div>
                        </div>
                    </div>
                </div>
                <div class="diagram">
                    <div class="content row-center" style="justify-content:flex-start">
                        <div class="row-center">
                            <el-date-picker
                                    :editable="false"
                                    :picker-options="pickerOptions"
                                    :clearable="false"
                                    class="dateSelect"
                                    v-model="date"
                                    type="date"
                                    :placeholder="new Date().toLocaleDateString().replace(/\//g, '-')"
                            >
                            </el-date-picker>
                            <el-select
                                    style="width: 120px !important"
                                    class="node-select"
                                    v-model="k1"
                                    placeholder="请选择"
                            >
                                <!-- 谐波 -->
                                <el-option label="电压" value="0">电压</el-option>
                                <el-option label="电流" value="1">电流</el-option>
                            </el-select>
                            <el-select
                                    style="width: 120px !important"
                                    class="node-select"
                                    v-model="k2"
                                    placeholder="请选择"
                            >
                                <el-option
                                    v-for="i in realData"
                                    :key="i.id"
                                    :value="i.id"
                                    :label="i.name"
                                >
                                </el-option>
                            </el-select>
                            <el-button
                                    class="btn per"
                                    plain
                                    @click="perD">上一日</el-button>
                            <el-button
                                    class="btn next"
                                    plain
                                    @click="nextD"
                                    :disabled="nextDayDisabled"
                            >下一日
                            </el-button
                            >
                        </div>
                        <div class="row-center">
                            <div class="max">
                                <el-checkbox
                                        label="最值分析"
                                        name="type"
                                        v-model="item.showMax"
                                        @change="handleCheckChange"
                                >
                                </el-checkbox>
                            </div>
                            <div class="export ">
                                <img
                                        style="width: 14px; height: 14px"
                                        src="../../assets/img/export.png"
                                        alt=""
                                />
                                <span
                                        style="font-size: 14px; cursor: pointer"
                                        @click="exportFunc(item)"
                                >导出图表</span>
                                
                            </div>
                        </div>
                    </div>
                    <HarmonicItem :showMax="item.showMax" :diagramData="item.diagramData"></HarmonicItem>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    
    import {
        harmonicAnalysis,LOOP_DIAGRAM_DATA_BY_DAY,GET_AREAS,getLoadCharts
    } from "../../api/power";
	import {floatFormat} from "../../util/MathUtil";
    import { subscribe } from '../../mqtt/index'
	import Curve from "../Comparison/components/Curve.vue";
	import HarmonicItem from "./components/HarmonicItem.vue";
    import {
		dateFormat,
		dayEnd,
		dayStart,
		nextDay,
		nextMonth,
		nextYear,
		perDay,
		perMonth,
		perYear,
	} from "../../util/DateUtil";
    export default {
        name: "Harmonic",
        components: {
            Curve,HarmonicItem
        },
        data() {
            return {
                pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
				},
				date: new Date(),
                k1:'0',
                k2:0,
                deviceLoops:[],
                options:[
                {
                    type: "实时电压总谐波",
                    details: [{
                            key: "",
                            unit: "%",
                            data: {
                                "A": "THD_Ua",
                                "B": "THD_Ub",
                                "C": "THD_Uc",
                            }
                        },

                    ]
                },
                {
                    type: "实时电流总谐波",
                    details: [{
                            key: "",
                            unit: "%",
                            data: {
                                "A": "THD_Ia",
                                "B": "THD_Ib",
                                "C": "THD_Ic",
                            }
                        },

                    ]
                }],
                AreaList:[]
            }
        },
        computed:{
            AreaName(id){
                return function(id) {
                   let data =  this.AreaList.filter(e=>{
                        if(e.areaId == id){
                            return e
                        }
                    })
                  return  data[0].areaName
                }
            },
			mqttval() {
				return this.getMqttVal(this.$store.getters.mqttVal);
			},
            fow(item) {
                return function(item){
                    if (
                        this.$store.getters.mqttVal(item.subLoopUrl + "/THD_Ua") >
                        4 ||
                        this.$store.getters.mqttVal(item.subLoopUrl + "/THD_Ub") >
                        4 ||
                        this.$store.getters.mqttVal(item.subLoopUrl + "/THD_Uc") > 4
                    ) {
                        return 5;
                    } else {
                        return 1;
                    }
                }
			},
            //  单数
			realData() {
                var a = [];
                if(this.k1==0){ //电压
                    a = [{id:0,name:"总谐波",data:{A:"THD_Ua",B:"THD_Ub",C:"THD_Uc"}}]
                    for (var i = 2; i < 25; i++) {
                        if (i % 2 == 1) {
                            a.push({
                                id:i,
                                name:i+"次谐波",
                                data:{A:"H_Ua_"+i,B:"H_Ub_"+i,C:"H_Uc_"+i}
                            });
                        }
                    }
                }else{
                    a = [{id:0,name:"总谐波",data:{A:"THD_Ia",B:"THD_Ib",C:"THD_Ic"}}]
                    for (var i = 2; i < 25; i++) {
                        if (i % 2 == 1) {
                            a.push({
                                id:i,
                                name:i+"次谐波",
                                data:{A:"H_Ia_"+i,B:"H_Ia_"+i,C:"H_Ia_"+i}
                            });
                        }
                    }
                }
				return a;
			},
            nextDayDisabled() {
				let timestamp = dateFormat("YY-mm-dd", new Date());
				let endtime = dateFormat("YY-mm-dd", this.date);
				if (this.radio === "year") {
					timestamp = dateFormat("YY", new Date());
					endtime = dateFormat("YY", this.date);
				} else if (this.radio === "month") {
					timestamp = dateFormat("YY-mm", new Date());
					endtime = dateFormat("YY-mm", this.date);
				}
				// console.log(endtime,timestamp)
				if (endtime >= timestamp) {
					return true;
				} else {
					return false;
				}
			},
            updataData(){
                return [
                    this.k1,this.k2,this.date
                ]
            }
            
        },
        watch:{
            updataData(){
                
                this.deviceLoops.forEach((item,index)=>{
                    this.canvasDataRult(item,index)
                })
            }
        },
        mounted(){
            this.getharmonicAnalysis()
            GET_AREAS().then(res => {
                // console.log(res.data.data.areas)
                this.AreaList = res.data.data.areas
            })
        },
        methods: {
            handleCheckChange(val,data) {
                this.deviceLoops.forEach((item,index)=>{
                    this.canvasDataRult(item,index)
                })
            },
            async canvasDataRult(currentLoop,index) {
				let data = this.realData.filter(e=>e.id==this.k2)[0].data;
                let values = Object.values(data)
                

				let loopId = currentLoop.loopId;
				let promises = [];
				let legendTitle = [];

                let start = dayStart(this.date)
                let end = dayEnd(this.date)
                let objs = {
                    deviceLoopId:loopId,
                    start:start,
                    end:end,
                    group:"5m",
                    node:values.join(',')
                }
                let res = await getLoadCharts(objs)

                let datalist = res.data.data.points
                let pointsArray = []
				for (let key in data) {
					if (data.hasOwnProperty(key)) {
						let node = data[key];
						if (node) {
                            let k  = this.k1==0?"电压":"电流"
                            let k2 = this.realData.filter(e=>e.id==this.k2)[0].name
                            legendTitle.push(key+"相"+k+k2)
				            // promises.push(LOOP_DIAGRAM_DATA_BY_DAY(loopId, node, this.date));
						}
                        
                        for (let keys in datalist) {
                            let nodes = datalist[keys];
                            if(node==keys){
                                pointsArray.push(nodes)
                            }
                        }
					}
				}

				// Promise.all(promises).then((res) => {
					// pointsArray = Object.values(datalist)

					let obj = {};
                    let xAxisData = [];
                    let seriesData = [];
                    for (let index = 0; index < pointsArray[0].length; index++) {
                        const e = pointsArray[0][index];
                        if (e.val!='') {
                            xAxisData.push(e.time.split('T')[1].substr(0, 5));
                        }
                    }

					pointsArray.forEach((e, i) => {
						seriesData.push({
							name: legendTitle[i],
							data:e.map((p) => {
                                let v = p.val;
                                if(v!=""){
                                    return Number(v).toFixed(2)
                                }else{
                                    return ""
                                }
                                
                            }).filter(e=>e!='')
						});

					});
                    this.deviceLoops[index].diagramData = this.createCanvasData(legendTitle, xAxisData, seriesData,index)
				// });
				return true;
			},
            
            createCanvasData(legendData, xAxisData, seriesData,index) {
                
                let series;
                let markPoint;
                if(this.deviceLoops[index].showMax){
                    markPoint = {
						data: [
							{
								type: "max",
								name: "最大值",
							},
							{
								type: "min",
								name: "最小值",
							},
						],

						symbol: "pin",
						symbolSize: "20",
						label: {
							position: "top",
						},
					}
                }
                series = seriesData.map((e) => {
                    return {
                        smooth: true,
                        symbol:'none',
                        name: e.name,
                        step: 'start',
                        type: "line",
                        data: e.data,
                        connectNulls: true,
                        markPoint:markPoint
                    }
                });
                let color = ["#F6BD16", "#5AD8A6", "#E8684A", "#5D7092"];

                return {
                    color,
                    tooltip: {
                        trigger: "axis",
                        textStyle: {
                            color: "#333333" //设置文字颜色
                        },
                        formatter: function (params) {
                            let str = `${params[0].name}<br/>`;
                            params.forEach((item, idx) => {
                                str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.data}</b><b style='font-size:14px;'> %</b>`;
                                str += idx === params.length -1? '': '<br/>'
                            })
                            return str
                        }
                    },
                    legend: {
                        top: 0,
                        itemWidth: 10,
                        itemHeight: 10,
                        icon: "rect",
                        data: legendData,
                        textStyle: {
                            fontSize: "16rem"
                        },
                        itemGap: 20,
                        itemStyle: {

                        }
                    },
                    grid: {
                        left: 10,
                        right: 10,
                        top:"10%",
                        bottom: "7%",
                        containLabel: true
                    },
                    toolbox: {
                        feature: {
                        },
                    },
                    xAxis: {
                        type: "category",
                        boundaryGap: false,
                        data: xAxisData,
                        splitLine: {
                            show: true
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#CCCCCC",
                                width: 1,
                                type: "solid",
                            },
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999",
                            },
                        },
                    },
                    yAxis:{
                        nameTextStyle: {
                            color: "#999999",
                            fontSize: "14",
                        },
                        boundaryGap: true,
                        axisTick: {
                            show: false,
                        },
                        show: true,
                        spiltLine: {
                            show: true
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#CCCCCC",
                                width: 1,
                                type: "solid",
                            },
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999",
                            },
                        },
                        type: "value",
                        name:"%"
                    },
                    series,
                };
            },
			exportFunc(item) {
				if (!item.diagramData.xAxis.data.length) {
					this.$message.warning("无图表数据！");
					return;
				}
                this.$store.commit("exportDiagram", {
                    type: "echarts",
                    version: Math.random(),
                });
			},
            getMqttVal(f) {
				return (k, m) => {
					if (k) {
						
						let mqttVal = f(k);
						if (m) {
							mqttVal *= m;
						}

						mqttVal = floatFormat(mqttVal, 2);

						// console.log(typeof mqttVal)

						if (typeof mqttVal === "object") {
							return mqttVal;
						}

						return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
					} else {
						return "--";
					}
				};
			},
            async getharmonicAnalysis() {
                let res = await harmonicAnalysis(this.$store.getters.projectId)
                if (res.data.data.deviceLoops) {
                    this.deviceLoops = res.data.data.deviceLoops.filter((d) => {
                        if (d.harmonic == 1) {
                            subscribe([d.subLoopUrl]);
                            // this.canvasDataRult(d)
                            
                            d.diagramData = {}
                            d.showMax = true
                            return d;
                        }})
                        console.log(this.deviceLoops,"this.deviceLoops")
                        this.deviceLoops.forEach((item,index)=>{
                            this.canvasDataRult(item,index)
                        })

                   
                }
            },
            perD() {
				this.date = perDay(this.date);
				// this.nextDayDisabled(this.date);
			},
			nextD() {
				this.date = nextDay(this.date);
				// this.nextDayDisabled(this.date);
			},
        },
    };
</script>

<style lang="less" scoped>
/deep/.el-button{
    background-color: transparent !important;
}
/deep/.el-input__inner{
    background-color: transparent !important;
}
    .Harmonic{
        overflow: auto;
        height: 100%
    }
    .power-data{
        
		.tit {
            font-size: 18rem;
            font-weight: bold;
            color: #333333;
            line-height: 50rem;
		}
        .Harmonic-data{
            background: rgba(0, 0, 0, 0.02);
            padding: 20px
        }
        .real-data {
            // padding: 24rem;
            // .h(150);
            .location-right {
                .w(492);
                .h(150);
                // position: absolute;
                // right: 69rem;
                padding: 16rem 0 0 18rem;
                background: rgba(0, 43, 102, 0.04);

                .location-and {
                    display: flex;
                    align-items: center;
                    height: 34rem;

                    .location-img {
                        width: 34rem;
                        height: 34rem;
                        margin-right: 5px;
                    }

                    img {
                        width: 34rem;
                        height: 34rem;
                    }
                }

                .location-title {
                    // font-size: 24px;

                    font-size: 28rem;
                    font-weight: bold;
                    color: #68d86a;

                    line-height: 30px;
                }

                .location-orag {
                    font-size: 28rem;
                    font-weight: bold;
                    color: #f5aa00;
                    line-height: 30px;
                }

                .location-item {
                    margin-top: 15rem;
                    .w(420);
                    height: 63px;
                    font-size: 16rem;
                    font-weight: 400;
                    color: #666666;
                    word-wrap: break-word;
                    word-break: break-all;
                    overflow: hidden;
                    /*这个参数根据需求来决定要不要*/
                }
            }
            .row-data{
                justify-content: space-between;
            }
            .data {
                .w(280);
                margin-right: 20px;
                .name {
                    font-size: 16rem;
                    color: #333333;
                    font-weight: bold;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                    padding-bottom: 8rem;
                    // padding-left: 17rem;
                }
                .details {
                    .h(132);
                    justify-content: space-between;
                    font-size: 24rem;
                    font-weight: 600;
                    margin-top: 10px;
                    overflow: hidden;
                    .row {
                        margin-bottom: 5rem;
                        justify-content: flex-start;
                    }

                    .active {
                        span {
                            color: #fd4238;
                        }
                    }
                    .key {
                        color: #666666;
                        margin-right: 15px;
                    }

                    .val {
                        color: #0d94ff;
                        // .w(263);

                        // span {
                        //     display: inline-block;
                        //     width: 25%;
                        // }
                    }
                }
            }

        }
        .diagram {
            
            .h(518);
            margin-top: 8rem;

            // display: flex;
            .exetext {
                .w(728);
                display: flex;
                align-items: center;
                justify-content: space-between;

                .exetext1 {
                    display: flex;
                    align-items: center;
                }
            }

            .left {
                width: 100%;
                .h(480);
            }

            .echarts {
                width: 100%;

                .left {
                    width: 100%;
                    .h(460);
                }

                .max-right {
                    .w(272);
                    // height: 380px;
                    .h(460);
                    margin-right: 24rem;

                    .row-max {
                        width: 100%;
                        background-color: rgba(0, 43, 102, 0.02);
                        // height: 88px;
                        margin-bottom: 10px;

                        .details {
                            .w(176);
                            height: 100%;
                            padding: 12rem 0;

                            span {
                                margin-right: 8rem;
                                color: rgba(13, 148, 255, 1);
                                font-size: 16rem;

                                &:first-child {
                                    color: #333333;
                                }
                            }
                        }

                        .max-name {
                            height: 100%;
                            .w(96);
                            font-size: 18rem;
                            font-weight: bold;
                            color: #333333;
                        }
                    }
                }
            }

            .showMax {
                div.left {
                    .w(920) !important;
                }
            }

            .tab {
                width: 100%;
                .h(438);
                margin-top: 25rem;
            }

            .content {
                margin-top: 10rem;

                .dateSelect {
                    font-size: 18rem;
                    color: #000000 !important;
                    margin-right: 8rem;
                }
                .node-select{
                    margin-right: 8rem;
                }

                .max {
                    .w(100);
                    margin-left: 27rem;
                }

                .hose {
                    display: flex;
                    align-items: center;
                }
            }

        }
    }
    
</style>